import { render, staticRenderFns } from "./PanelBeneficios.vue?vue&type=template&id=449bc1ee&scoped=true&"
import script from "./PanelBeneficios.vue?vue&type=script&lang=js&"
export * from "./PanelBeneficios.vue?vue&type=script&lang=js&"
import style0 from "./PanelBeneficios.vue?vue&type=style&index=0&id=449bc1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bc1ee",
  null
  
)

export default component.exports